import useSWR from 'swr';
import { LeagueAdvancedStatsFragment } from '@amf/shared/types/graphql';

const PATH = '/api/league/advanced-stats';
const getKey = (id: string) => () => {
  const params = new URLSearchParams({ id });
  return `${PATH}?${params.toString()}`;
};

function useLeagueAdvancedStats(leagueId: string) {
  const { data, error } = useSWR<LeagueAdvancedStatsFragment | null>(getKey(leagueId));
  return {
    error,
    stats: data,
    loading: !data && !error,
  };
}

export default useLeagueAdvancedStats;
